import { cn } from '@/services/utils';

type BrandLogoProps = {
  className?: string;
  markClassName?: string;
  textClassName?: string;
  compact?: boolean;
};

export function BrandLogo({
  className,
  markClassName,
  textClassName,
  compact = false,
}: BrandLogoProps) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <img
        src="/favicon.svg"
        alt=""
        aria-hidden="true"
        className={cn('size-11 shrink-0', markClassName)}
      />
      {!compact && (
        <img
          src="/yawca-text-vector.svg"
          alt="yawca"
          className={cn('h-6 w-auto shrink-0', textClassName)}
        />
      )}
    </span>
  );
}
